'use strict';

var reviewScore = require('../review/reviewScore');
var renderCharts = require('../charts/chartsRender');
var competizeAll = require('../review/competitors/competizeAll');
var fixInnerIssue = require('./fixInnerIssue');
var rgba2hex = require('./rgbaToHex');
var colors = require('../charts/chartsColors');

function colorIsSettable (color) {
  // We only allow colors defined as '#xyz' or '#xxyyzz', which differ from primaryDarker
  return (
    color &&
    color.toUpperCase() !== colors.primaryDarker &&
    color.match(/^#([a-f0-9]{3}|[a-f0-9]{6})$/i)
  );
}

// Charts customs colors options
if (colorIsSettable(window.customColor)) {
  var r = parseInt(window.customColor[1] + window.customColor[2], 16);
  var g = parseInt(window.customColor[3] + window.customColor[4], 16);
  var b = parseInt(window.customColor[5] + window.customColor[6], 16);

  window.mapColors = {
    0: '#' + rgba2hex(r, g, b, 0.09),
    10: '#' + rgba2hex(r, g, b, 0.18),
    20: '#' + rgba2hex(r, g, b, 0.27),
    30: '#' + rgba2hex(r, g, b, 0.36),
    40: '#' + rgba2hex(r, g, b, 0.45),
    50: '#' + rgba2hex(r, g, b, 0.54),
    60: '#' + rgba2hex(r, g, b, 0.63),
    70: '#' + rgba2hex(r, g, b, 0.72),
    80: '#' + rgba2hex(r, g, b, 0.81),
    90: '#' + rgba2hex(r, g, b, 0.9),
    100: window.customColor
  };

  window.customColor2 = window.customColor2 || $('body').attr('c-1');
  window.customColor3 = window.customColor3 || $('body').attr('c-2');
  window.customColor4 = window.customColor4 || $('body').attr('c-3');

  window.Highcharts.theme = {
    colors: [
      '#' + window.customColor,
      window.customColor2,
      window.customColor3,
      window.customColor4,
      colors.greyMedium
    ]
  };
  window.highchartsOptions = window.Highcharts.setOptions(
    window.Highcharts.theme
  );
} else {
  window.customColor = colors.primaryDarker;
}

if (!window.isInside) {
  reviewScore.init({animate: false});
  competizeAll(true);
}

if ($('#pdf-header').hasClass('slide')) {
  var heightTmp;
  var paddingTmp;
  var paddingTmp2;

  $('.criterium').each(function () {
    heightTmp = $(this).height();

    if (heightTmp < 630) {
      paddingTmp = (630 - heightTmp) / 2;
      return $(this).css('padding-top', paddingTmp + 'px');
    }
  });

  heightTmp = $('#summary').height();

  if (heightTmp < 630) {
    paddingTmp = (630 - heightTmp) / 2;
    $('#summary').css('padding-top', paddingTmp + 'px');
  }

  heightTmp = $('#pdf-footer').height();

  if (heightTmp < 630) {
    paddingTmp2 = (630 - heightTmp) / 2;
    $('#pdf-footer').css('padding-top', paddingTmp2 + 'px');
  }
}

window.mustacheTemplates = {};
window.mustacheMainTemplate = '';
fixInnerIssue();
renderCharts();
